import React from 'react';
import Grades from './';

export default function GradesStudentView(props) {
  return <Grades {...props} studentView />;
}
